import {
  Box,
  Button,
  Drawer,
  Grid,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import SearchItm from "../assests/search.svg";
import MoreIcon from "../assests/more.svg";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import WatchLaterRoundedIcon from "@mui/icons-material/WatchLaterRounded";
import SendIcon from "../assests/send.png";
import "./CommonTicket.css";
import { useMediaQuery, useTheme } from "@mui/material";
import TicketDetailsModal from "./TicketModal";
import TIcketDrawer from "./TicketDrawer";
import { getMessageApi, sendMsgApi, ticketStatusApi } from "../../api";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import Picker from "emoji-picker-react";
import { useRef } from "react";
dayjs.extend(relativeTime);

const CommonTicket = ({ AllTicket,loadMore, hasMore,  setAllTicketData}) => {
  const token = useSelector((state) => state?.user?.user?.token);
  const theme = useTheme();
  const isBelowMd = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [activeTicketId, setActiveTicketId] = useState(null);
  // const [searchQuery, setSearchQuery] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sendMessage, setSendMessage] = useState("");
  const [messageData, setMessageData] = useState([]);
  const [change, setChange] = useState(false);
  const [myTimout, setMyTimeOut] = useState(null);
  const [id, setId] = useState("");
  const [emojiPickerOpen, setEmojiPickerOpen] = useState(false);

  const chatContainerRef = useRef(null);
  // Reference for the chat container
  const [isAtBottom, setIsAtBottom] = useState(true);
  // Track if the user is at the bottom

  const handleDrawerOpen = (ticket) => {
    setSelectedTicket(ticket);
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => setDrawerOpen(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleEmojiClick = (emoji) => {
    setSendMessage((prevMessage) => prevMessage + emoji.emoji);
    setEmojiPickerOpen(false);
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleViewDetails = () => {
    handleOpen(selectedTicket);
    handleMenuClose();
  };

  // const handleSearchInputChange = (e) => {
  //   setSearchQuery(e.target.value);

  //   onSearchChange(e.target.value);
  // };

  // Fetch messages for the active ticket
  const handleAllOpenMessage = async (id) => {
    try {
      setLoading(true);
      const response = await getMessageApi({ token, id: id });
      setMessageData(response?.conversation?.messages || []);
      setLoading(false);
      toast.success(response?.message);
      setId(id);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  // Fetch messages when the component mounts for the first ticket
  useEffect(() => {
    if (AllTicket?.length > 0 && !selectedTicket) {
      const firstTicket = AllTicket[0];
      setActiveTicketId(firstTicket?._id);
      setSelectedTicket(firstTicket);
      // Fetch messages for the first ticket
      handleAllOpenMessage(firstTicket?._id);
    }
  }, [AllTicket, selectedTicket]);

  // Close selected ticket
  // const handleTicketClose = async (id) => {
  //   const isConfirmed = window.confirm(
  //     "Are you sure, you want to Close this Ticket?"
  //   );
  //   if (!isConfirmed) return;
  //   try {
  //     const status = "Closed";
  //     const response = await ticketStatusApi({ token, id: id, status });

  //     toast.success(response?.message);
  //     // Notify parent of ticket closure
  //     onTicketClose();
  //   } catch (error) {
  //     toast.error(error?.message || error?.error || "ticket not closed");
  //     console.log("error", error);
  //   }
  // };

  const handleTicketClose = async (id) => {
    // Step 1: Confirm if the user really wants to close the ticket
    const isConfirmed = window.confirm("Are you sure, you want to Close this Ticket?");
    if (!isConfirmed) return;
  
    // Step 2: Optimistically update the status locally
    const updatedTickets = AllTicket.map(ticket => 
      ticket._id === id ? { ...ticket, status: "Closed" } : ticket
    );
    setAllTicketData(updatedTickets);  // Update local state immediately
  
    // Also update the selectedTicket if the closed ticket is the selected one
    if (selectedTicket?._id === id) {
      setSelectedTicket((prevTicket) => ({
        ...prevTicket,
        status: "Closed",
      }));
    }
  
    // Step 3: Call the API to change the status
    try {
      const status = "Closed";
      const response = await ticketStatusApi({ token, id, status });  // API call to close the ticket
  
      // Step 4: If the API request is successful
      toast.success(response?.message || "Ticket closed successfully");
      // loadMore();  
      // onTicketClose()
      // Optionally, you can do any additional updates or re-fetching here if needed
      setChange(!change);  // Re-trigger a re-render or fetch tickets again
    } catch (error) {
      // Step 5: If the API fails, revert the status back to the original one (i.e., Open)
      toast.error(error?.message || "Failed to close ticket");
  
      // Revert the local status change if the API request fails
      const revertedTickets = AllTicket.map(ticket => 
        ticket._id === id ? { ...ticket, status: "Open" } : ticket
      );
      setAllTicketData(revertedTickets);  // Revert to original state
  
      // Also revert selectedTicket if needed
      if (selectedTicket?._id === id) {
        setSelectedTicket((prevTicket) => ({
          ...prevTicket,
          status: "Open",
        }));
      }
    }
  };
  
  

  const handleSendMsg = async (id) => {
    if (!sendMessage.trim()) {
      toast.error("Message cannot be empty");
      return;
    }
    try {
      const response = await sendMsgApi({
        token,
        id: id,
        message: sendMessage,
      });
      // console.log("gg", response);
      setSendMessage("");
      // Append the new message to the messageData array
      setMessageData((prevMessages) => [
        ...prevMessages,
        {
          _id: response?.data?.messageId || new Date().getTime(),
          message: sendMessage,
          // sender: false,
          // updatedAt: new Date().toISOString(),
        },
      ]);
      // toast.success(response?.message);
      setChange(!change);
    } catch (error) {
      // toast.error(error?.message || "Message could not be sent");
      toast.error(
        error?.message || error?.error || "Message could not be sent"
      );
      console.error("Error sending message:", error);
    }
  };

  useEffect(() => {
    const myTimout = setInterval(() => {
      if (id != "") {
        handleAllOpenMessage(id);
      }
    }, 30000);
    return () => clearInterval(myTimout);
  }, []);

  // When a new ticket is selected, update the ticket details and fetch the messages
  const handleTicketSelect = (item) => {
    setActiveTicketId(item._id);
    setSelectedTicket(item);
    handleAllOpenMessage(item._id);
    handleDrawerOpen(item);
  };

  const formatDate = (date) => {
    if (dayjs().isSame(date, "day")) return "Today";
    if (dayjs().subtract(1, "day").isSame(date, "day")) return "Yesterday";
    return dayjs(date).format("MMMM D, YYYY");
  };

  
  const checkIfAtBottom = () => {
    const container = chatContainerRef.current;
    if (container) {
      const isAtBottom =
        container.scrollHeight - container.scrollTop === container.clientHeight;
      setIsAtBottom(isAtBottom);
    }
  };

  // Scroll to bottom only if the user is at the bottom of the container
  const scrollToBottom = () => {
    if (chatContainerRef.current && isAtBottom) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  };

  // Scroll to the bottom whenever new messages are added (only if the user is at the bottom)
  useEffect(() => {
    scrollToBottom();
  }, [messageData]);

  // Set the state to "not at bottom" if the user manually scrolls up
  useEffect(() => {
    const container = chatContainerRef.current;
    if (container) {
      container.addEventListener("scroll", checkIfAtBottom);
    }

    // Cleanup the event listener
    return () => {
      const container = chatContainerRef.current;
      if (container) {
        container.removeEventListener("scroll", checkIfAtBottom);
      }
    };
  }, []);

  return (
    <>
      <Box className="chat-container">
        <Grid container spacing={2} className="chat-grid-container">
          <Grid item xs={12} sm={6} md={4} className="chat-left-column">
            <Box className="chat-left-box" id="scrollableDiv">
              <InfiniteScroll
                dataLength={AllTicket.length}
                next={loadMore}
                hasMore={hasMore}
                loader={<h4>Loading...</h4>}
                endMessage={
                  <p style={{ textAlign: "center" }}>
                    <b>You have seen it all</b>
                  </p>
                }
                scrollableTarget="scrollableDiv"
                key={AllTicket.length}
              >
                {/* <div > */}
                <Box className="chat-ticket-list">
                  {AllTicket?.length > 0 ? (
                    AllTicket.map((item, index) => (
                      <Box
                        key={item._id}
                        className={`chat-ticket-item ${
                          activeTicketId === item._id
                            ? "active-ticket"
                            : "non-active-ticket"
                        }`}
                        onClick={() => handleTicketSelect(item)}
                      >
                        <Box className="ticket-header">
                          <div className="ticket-title">
                            {item?.title || "N/A"}
                          </div>
                          <Box
                            className={`ticket-status ${
                              item?.status === "Open"
                                ? "ticket-open"
                                : item?.status === "Reported"
                                ? "ticket-reported"
                                : "ticket-closed"
                            }`}
                          >
                            {item?.status || "N/A"}
                          </Box>
                        </Box>
                        <Box className="ticket-date">
                          <WatchLaterRoundedIcon className="watch-icon" />
                          <Typography className="date-text">
                            {item?.createdAt
                              ? new Date(
                                  item?.createdAt || "-"
                                ).toLocaleDateString()
                              : "-"}
                          </Typography>
                        </Box>
                        <Typography className="ticket-description">
                          {item?.description || "N/A"}
                        </Typography>
                      </Box>
                    ))
                  ) : (
                    <div>No tickets available</div>
                  )}
                </Box>
                {/* </div> */}
              </InfiniteScroll>
            </Box>
          </Grid>

          {/* Right Column */}
          <Grid item spacing={0.2}>
            <div className="intersection-line"></div>
          </Grid>

          {selectedTicket && (
            <Grid item xs={12} sm={5.6} md={7.6} className="chat-right-column">
              <Box className="chat-ticket-details">
                <Box className="ticket-info-header">
                  <Typography className="ticket-info">
                    <div className="ticket-title-details">
                      {selectedTicket?.title || "N/A"}
                      <p className="ticket-number">
                        Ticket no: #{selectedTicket?.ticketNumber || "-"}
                      </p>
                    </div>
                    <div
                        className={`ticket-status-details ${
                          selectedTicket?.status === "Open"
                            ? "ticket-open"
                            : selectedTicket?.status === "Reported"
                            ? "ticket-reported"
                            : "ticket-closed"
                        }`}
                      >
                      {selectedTicket?.status || "N/A"}
                    </div>
                  </Typography>
                  <Box>
                    <IconButton onClick={handleMenuClick}>
                      <img src={MoreIcon} />
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleMenuClose}
                      PaperProps={{
                        style: {
                          borderRadius: "12px 0px 12px 12px",
                          background: "#FFF",
                          boxShadow: "1px 2px 16px 0px rgba(0, 0, 0, 0.10)",
                        },
                      }}
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                      transformOrigin={{ vertical: "top", horizontal: "right" }}
                    >
                      <MenuItem key="view-details" onClick={handleViewDetails}>
                        View Details
                      </MenuItem>
                      {selectedTicket?.status !== "Closed" && (
                        <MenuItem
                          key="close-ticket"
                          onClick={() => handleTicketClose(selectedTicket?._id)}
                        >
                          Close Ticket
                        </MenuItem>
                      )}
                    </Menu>
                  </Box>
                </Box>
              </Box>

              <Box className="chat-messages-container" ref={chatContainerRef}>
                {messageData
                  .sort((a, b) =>
                    dayjs(a.updatedAt).isBefore(dayjs(b.updatedAt)) ? -1 : 1
                  ) // Sort messages by timestamp
                  .map((message, index) => {
                    // Check if we need to display a date separator (if it's a different day)
                    const showDate =
                      index === 0 ||
                      !dayjs(messageData[index - 1].updatedAt).isSame(
                        message.timestamp,
                        "day"
                      );

                    return (
                      <React.Fragment key={message?._id}>
                        {showDate && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              marginBottom: "5px",
                            }}
                          >
                            <div
                              style={{
                                color: "gray",
                                fontSize: "12px",
                                background: "#E8E8E8",
                                height: "31px",
                                padding: "7px",
                                borderRadius: "28px",
                                marginBottom: "2px",
                                opacity: "0.6",
                              }}
                            >
                              {formatDate(message?.updatedAt)}
                            </div>
                          </div>
                        )}

                        {/* Message Box */}
                        <Box
                          className={`chat-message ${
                            message?.sender
                              ? "message-incoming"
                              : "message-outgoing"
                          }`}
                          style={{
                            textAlign: message?.sender ? "left" : "right",
                            marginBottom: "10px",
                          }}
                        >
                          <Typography
                            className="message-text"
                            style={{
                              fontFamily: "Heebo",
                              display: "inline-block",
                              maxWidth: "80%",
                              wordWrap: "break-word",
                              background: message?.sender
                                ? "#E8E8E8"
                                : "linear-gradient(112deg, #07523D 7.8%, #168F6D 78.62%)",
                              padding: "8px 12px",
                              borderRadius: message?.sender
                                ? "18px 18px 18px 0px"
                                : "18px 18px 0px 18px",
                              color: message?.sender ? "#362B24" : "white",
                            }}
                          >
                            {message?.message}
                          </Typography>

                          {/* Timestamp */}
                          <Typography
                            className="message-time"
                            style={{
                              fontSize: "11px",
                              color: "gray",
                              marginTop: "5px",
                              textAlign: message?.sender ? "left" : "right",
                            }}
                          >
                            {dayjs(message?.updatedAt).format("h:mm A")}
                          </Typography>
                        </Box>
                      </React.Fragment>
                    );
                  })}
                {/* <div ref={messageEndRef} />  */}
              </Box>

              {selectedTicket?.status === "Open" && (
                <Box className="chat-input-section">
                  <EmojiEmotionsIcon
                    className="emoji-icon"
                    onClick={() => setEmojiPickerOpen(!emojiPickerOpen)}
                  />

                  {/* Emoji Picker */}
                  {emojiPickerOpen && (
                    <Box className="emoji-picker-container">
                      <Picker onEmojiClick={handleEmojiClick} />
                    </Box>
                  )}
                  <input
                    type="text"
                    className="chat-input"
                    value={sendMessage}
                    onChange={(e) => setSendMessage(e.target.value)}
                  />
                  <div
                    className="send-button"
                    onClick={() => handleSendMsg(selectedTicket?._id)}
                  >
                    <img src={SendIcon} alt="send-icon" className="send-icon" />
                  </div>
                </Box>
              )}
            </Grid>
          )}
        </Grid>
      </Box>

      <TicketDetailsModal
        open={open}
        handleClose={handleClose}
        selectedTicket={selectedTicket}
      />

      <TIcketDrawer
        drawerOpen={drawerOpen}
        isBelowMd={isBelowMd}
        handleDrawerClose={handleDrawerClose}
        selectedTicket={selectedTicket}
        messsageData={messageData}
        handleOpen={handleOpen}
        onCloseTicket={handleTicketClose}
        dateFormate={formatDate}
        sendMessage={sendMessage}
        setSendMessage={setSendMessage}
        handleSendMsg={handleSendMsg}
        chatRef={chatContainerRef} 
      />
    </>
  );
};

export default CommonTicket;
